import axios, { AxiosInstance } from 'axios';
import refreshTokenInterceptor from '@/lib/http/refreshTokenInterceptor';
import baseRequestInterceptor from '@/lib/http/baseRequestInterceptor';
import baseResponseInterceptor from '@/lib/http/baseResponseInterceptor';
import { installSentryAxiosInterceptor } from '@/lib/sentry/sentryInterceptor';

const timeoutSeconds = 45;

export function createAxiosInstance(baseURL: string): AxiosInstance {
    const axiosInstance: AxiosInstance = axios.create({
        baseURL,
        timeout: timeoutSeconds * 1000,
        timeoutErrorMessage: `Time out, server did not respond in ${timeoutSeconds}s `,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
    });

    refreshTokenInterceptor(axiosInstance);
    baseRequestInterceptor(axiosInstance);
    baseResponseInterceptor(axiosInstance);
    installSentryAxiosInterceptor(axiosInstance);

    return axiosInstance;
}
